import SwApp from './sw-app.vue';

export {
  SwApp,
};
